"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationBehavior',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        follow: '跟进',
        convert: '转化',
        ignore: '忽略'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationBehaviorListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('案例/对象 ID', '记录收藏').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationBehaviorSaveApi)({
          behaviorType: 'favorite',
          objectType: 'content',
          objectId: Number(value || 1),
          sourcePage: 'merchant-admin',
          durationSeconds: 12
        }).then(function () {
          _this2.$message.success('行为已记录');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationBehaviorActionApi)(row.behavior.id, {
          action: action
        }).then(function () {
          _this3.$message.success('行为已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};